<template>
  <div style="width: 100%">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-toolbar flat>
            <v-toolbar-title>
              <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
                GRÁFICOS
              </h2>
            </v-toolbar-title>
          </v-toolbar>
        </v-row>
        <v-row class="justify-center">
          <bubble-chart
            :dados="dadosGraficos.bubbleChart"
            :fonte="`Fonte: Sistema Desenvolva, ${anoDiagnostico}`"
            class="bubble-chart"
            descricao-eixo-x="COMPORTAMENTO"
            descricao-eixo-y="RESPONSABILIDADE"
            titulo="Matriz de Desempenho - Comportamento x Responsabilidade"
            :is-get-svg="isGetSvg"
            @svg="(value) => svg = value"
          />
        </v-row>
        <v-row class="justify-center">
          <v-col>
            <v-row
              ref="graficos"
              class="justify-center"
            >
              <gauge-chart-cds
                :dados="dadosGraficos.gaugeChart"
                :descricao-titulo="tituloGraficoGauge"
                :fonte="`Fonte: Sistema Desenvolva, ${anoDiagnostico}`"
                :titulo="tituloGraficoGauge"
                class="gauge-chart"
                descricao="<span style='font-style: italic'>(Comportamental x Responsabilidade)/10</span>"
              />
            </v-row>
          </v-col>
        </v-row>
        <!-- legenda do gauge-chart -->
        <v-row class="justify-center">
          <legenda-cds />
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :disable-pagination="tipo === 'SERVIDOR'"
              :headers="headers"
              :hide-default-footer="tipo === 'SERVIDOR'"
              :items="desempenhosServidores"
              :search="opcoes.pesquisa"
              :sort-by="opcoes.ordenarPor"
              :sort-desc="opcoes.decrescente"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-row class="mb-2">
                  <v-toolbar flat>
                    <v-toolbar-title>
                      <h2 class="title primary--text text--darken-1 text-no-wrap">
                        RESULTADOS
                      </h2>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-row>
                <v-row v-if="tipo === 'UNIDADE'">
                  <v-col cols="12" md="4">
                    <app-sort v-model="opcoes" />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="situacao"
                      :items="situacoes"
                      item-text="text"
                      item-value="id"
                      label="Situação:"
                      prepend-icon="filter_list"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <app-search v-model="opcoes" />
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.tipo`]="{ item }">
                {{ item.chefia ? "GESTOR" : "SERVIDOR" }}
              </template>
              <template v-slot:[`item.notaComportamental`]="{ item }">
                {{ item.notaAgrupada | decimal }}
              </template>
              <template v-slot:[`item.notaResponsabilidade`]="{ item }">
                {{ item.notaAgrupadaResponsabilidade | decimal }}
              </template>
              <template v-slot:[`item.resultado`]="{ item }">
                <span :class="item.cds >= 9 ? 'font-weight-bold' : ''">{{ item.cds | decimal }}</span>
              </template>
              <template v-slot:[`item.naoAtende`]="{ item }">
                <v-icon
                  v-if="item.cds < 4"
                  color="grey"
                >
                  check_box
                </v-icon>
                <v-icon
                  v-else
                  color="grey"
                >
                  check_box_outline_blank
                </v-icon>
              </template>
              <template v-slot:[`item.emDesenvolvimento`]="{ item }">
                <v-icon
                  v-if="item.cds >= 4 && item.cds < 8"
                  color="grey"
                >
                  check_box
                </v-icon>
                <v-icon
                  v-else
                  color="grey"
                >
                  check_box_outline_blank
                </v-icon>
              </template>
              <template v-slot:[`item.atende`]="{ item }">
                <v-icon
                  v-if="item.cds > 8"
                  color="grey"
                >
                  check_box
                </v-icon>
                <v-icon
                  v-else
                  color="grey"
                >
                  check_box_outline_blank
                </v-icon>
              </template>
              <template v-if="tipo === 'UNIDADE'" v-slot:[`body.append`]>
                <tr>
                  <td align="right" colspan="3">
                    <strong class="subtitle-2 grey--text text--darken-2">MÉDIA</strong>
                  </td>
                  <td align="center">
                    <strong>{{ mediaComportamental | decimal }}</strong>
                  </td>
                  <td align="center">
                    <strong>{{ mediaResponsabilidade | decimal }}</strong>
                  </td>
                  <td align="center">
                    <strong>{{ mediaCds | decimal }}</strong>
                  </td>
                  <td colspan="3" />
                </tr>
                <tr>
                  <td align="right" colspan="3">
                    <strong class="subtitle-2 grey--text text--darken-2">DESVIO PADRÃO</strong>
                  </td>
                  <td align="center">
                    <strong>{{ desvioPadraoComportamental | decimal }}</strong>
                  </td>
                  <td align="center">
                    <strong>{{ desvioPadraoResponsabilidade | decimal }}</strong>
                  </td>
                  <td align="center">
                    <strong>{{ desvioPadraoCds | decimal }}</strong>
                  </td>
                  <td colspan="3" />
                </tr>
              </template>
            </v-data-table>
            <v-divider />
          </v-col>
        </v-row>
        <v-row
          class="justify-end mb-1"
        >
          <v-tooltip
            max-width="400"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-2"
                color="success"
                @click="getRelatorio(desempenhosServidores, tipo)"
                v-on="on"
              >
                <v-icon>get_app</v-icon>
                BAIXAR PDF
              </v-btn>
            </template>
            <span>Clique para baixar o relatório dos dados em formato PDF.</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mean, std } from 'mathjs';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import BubbleChart from '@/components/chart/BubbleChart';
import GaugeChartCds from '@/components/chart/GaugeChartCds';
import LegendaCds from '@/components/monitoramento/desempenho/cds/LegendaCds';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import { formatNomeSobrenome, formatNomeArquivo } from '@/modules/texto';
import Data from '@/modules/data';
import toDecimal from '@/filters/decimal';

export default {
  name: 'ComparativoCoeficiente',

  components: {
    AppSort,
    AppSearch,
    BubbleChart,
    GaugeChartCds,
    LegendaCds,
  },

  props: {
    desempenhos: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    unidades: {
      type: String,
      default: '',
      required: true,
    },
    tipo: {
      type: String,
      default: 'SERVIDOR',
      required: true,
    },
    menuAcesso: {
      type: String,
      default: 'DESEMPENHO',
      required: false,
    },
  },

  data() {
    return {
      headers: [
        { text: 'SERVIDOR', value: 'usuario.nome', sortable: false },
        {
          text: 'UNIDADE',
          value: 'unidade.sigla',
          sortable: false,
          align: 'center',
        },
        {
          text: 'CATEGORIA',
          value: 'tipo',
          sortable: false,
          align: 'center',
        },
        {
          text: 'RESULTADO COMPORTAMENTAL',
          value: 'notaComportamental',
          sortable: false,
          align: 'center',
        },
        {
          text: 'RESULTADO TÉCNICO',
          value: 'notaResponsabilidade',
          sortable: false,
          align: 'center',
        },
        {
          text: 'CDS',
          value: 'resultado',
          sortable: false,
          align: 'center',
        },
        {
          text: 'NÃO ATENDE',
          value: 'naoAtende',
          sortable: false,
          align: 'center',
        },
        {
          text: 'EM DESENVOLVIMENTO',
          value: 'emDesenvolvimento',
          sortable: false,
          align: 'center',
        },
        {
          text: 'ATENDE',
          value: 'atende',
          sortable: false,
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'usuario.nome',
        selecionado: { id: 'usuario.nome', descricao: 'Servidor' },
        lista: [
          { id: 'usuario.nome', descricao: 'Servidor' },
          { id: 'chefia', descricao: 'Categoria' },
          { id: 'notaAgrupada', descricao: 'Resultado Comportamental' },
          { id: 'notaAgrupadaResponsabilidade', descricao: 'Resultado Técnico' },
          { id: 'cds', descricao: 'CDS' },
        ],
      },
      situacoes: [
        { id: '', text: 'Todas' },
        { id: 'NAO_ATENDE', text: 'Não Atende' },
        { id: 'EM_DESENVOLVIMENTO', text: 'Em Desenvolvimento' },
        { id: 'ATENDE', text: 'Atende' },
      ],
      situacao: '',
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    ...mapState({
      usuario: (state) => state.auth.usuario,
    }),
    desempenhosServidores() {
      return this.desempenhos.filter(
        (d) => this.situacao === ''
          || (this.situacao === 'NAO_ATENDE' && d.cds < 4)
          || (this.situacao === 'EM_DESENVOLVIMENTO' && d.cds >= 4 && d.cds < 8)
          || (this.situacao === 'ATENDE' && d.cds >= 8),
      );
    },
    dadosGraficos() {
      const dados = this.desempenhosServidores
        .filter(
          (d) => d.teveAutoavaliacaoComportamental
            && d.teveAvaliacaoGestorComportamental
            && d.teveAutoavaliacaoResponsabilidade
            && d.teveAvaliacaoGestorResponsabilidade,
        )
        .map((d) => {
          let titulo;
          let cor = '#2D5269';

          if (d.usuario.id === this.usuario.id) {
            titulo = 'Seu<br/>Resultado';
            cor = '#348ECA';
          } else if (d.chefia) {
            titulo = `Gestor<br>(${d.unidade.sigla})`;
          } else {
            titulo = `Servidor<br>(${d.unidade.sigla})`;
          }

          return {
            x: parseFloat(d.notaAgrupada.toFixed(2)),
            y: parseFloat(d.notaAgrupadaResponsabilidade.toFixed(2)),
            z: parseFloat(d.cds.toFixed(2)),
            name: titulo,
            item: formatNomeSobrenome(d.usuario.nome),
            color: cor,
          };
        });

      let valorCds = 0;
      if (this.desempenhosServidores.length > 1) {
        const mediaComportamental = mean(this.desempenhosServidores.map((d) => d.notaAgrupada));
        const mediaResponsabilidade = mean(this.desempenhosServidores.map((d) => d.notaAgrupadaResponsabilidade));
        const mediaCds = mean(this.desempenhosServidores.map((d) => d.cds));

        const desvioPadraoComportamental = std(this.desempenhosServidores.map((d) => d.notaAgrupada));
        const desvioPadraoResponsabilidade = std(this.desempenhosServidores.map((d) => d.notaAgrupadaResponsabilidade));
        const desvioPadraoCds = std(this.desempenhosServidores.map((d) => d.cds));

        dados.push({
          x: parseFloat(mediaComportamental.toFixed(2)),
          y: parseFloat(mediaResponsabilidade.toFixed(2)),
          z: parseFloat(mediaCds.toFixed(2)),
          a: parseFloat(desvioPadraoComportamental.toFixed(2)),
          b: parseFloat(desvioPadraoResponsabilidade.toFixed(2)),
          c: parseFloat(desvioPadraoCds.toFixed(2)),
          name: 'Média e <br/> Desvio Padrão',
          item: `MÉDIA ${this.unidades}`,
          item_dp: `DESVIO PADRÃO ${this.unidades}`,
          color: '#00aba4',
        });
        valorCds = mediaCds;
      } else {
        valorCds = dados[0].z;
      }

      return { bubbleChart: dados, gaugeChart: [valorCds] };
    },
    tituloGraficoGauge() {
      if (this.desempenhosServidores.length > 1) {
        return 'Média dos Coeficientes de Desempenho dos Servidores (CDS)';
      }
      return 'Coeficiente de Desempenho do Servidor (CDS)';
    },
    anoDiagnostico() {
      return this.desempenhos.length > 0 ? this.desempenhos[0].diagnostico.ano : '';
    },
    mediaComportamental() {
      if (this.desempenhosServidores.length > 0) {
        return mean(this.desempenhosServidores.map((d) => d.notaAgrupada));
      }
      return 0;
    },
    mediaResponsabilidade() {
      if (this.desempenhosServidores.length > 0) {
        return mean(this.desempenhosServidores.map((d) => d.notaAgrupadaResponsabilidade));
      }
      return 0;
    },
    mediaCds() {
      if (this.desempenhosServidores.length > 0) {
        return mean(this.desempenhosServidores.map((d) => d.cds));
      }
      return 0;
    },
    desvioPadraoComportamental() {
      if (this.desempenhosServidores.length > 0) {
        return std(this.desempenhosServidores.map((d) => d.notaAgrupada));
      }
      return 0;
    },
    desvioPadraoResponsabilidade() {
      if (this.desempenhosServidores.length > 0) {
        return std(this.desempenhosServidores.map((d) => d.notaAgrupadaResponsabilidade));
      }
      return 0;
    },
    desvioPadraoCds() {
      if (this.desempenhosServidores.length > 0) {
        return std(this.desempenhosServidores.map((d) => d.cds));
      }
      return 0;
    },
  },

  methods: {
    async getRelatorio(desempenhos) {
      this.isGetSvg = true;
      await preparePdf(async () => {
        let nomeArquivo = 'relatorio';
        let titulo = '';
        let participantes = '';
        const diagnostico = desempenhos.length > 0 ? desempenhos[0].diagnostico : null;
        const usuario = desempenhos.length > 0 ? desempenhos[0].usuario.nome : '';
        let inicioComportamental = '';
        let fimComportamental = '';
        let inicioResponsabilidade = '';
        let fimResponsabilidade = '';
        let periodoComportamental = '';
        let periodoResponsabilidade = '';
        const colunas = [
          'SERVIDOR',
          'UNIDADE',
          'RESULTADO\nCOMPORTA-\nMENTAL',
          'RESULTADO\nTÉCNICO',
          'CDS',
          'SITUAÇÃO',
        ];
        let linhas = [];
        let rodape;

        if (diagnostico) {
          inicioComportamental = Data.format(diagnostico.inicioComportamental);
          fimComportamental = Data.format(diagnostico.fimComportamental);
          inicioResponsabilidade = Data.format(diagnostico.inicioResponsabilidadeChefia);
          fimResponsabilidade = Data.format(diagnostico.fimResponsabilidadeServidor);

          switch (this.tipo) {
            case 'SERVIDOR':
              nomeArquivo += `-coeficiente-desempenho-${formatNomeArquivo(desempenhos[0].usuario.nome)}`;
              titulo = 'Coeficiente de Desempenho';
              participantes = `Usuário(a): ${usuario}`;

              linhas = desempenhos.map((d) => [
                d.usuario.nome,
                d.unidade.sigla,
                toDecimal(d.notaAgrupada),
                toDecimal(d.notaAgrupadaResponsabilidade),
                toDecimal(d.cds),
                this.getSituacaoCds(d.cds),
              ]);
              break;
            case 'UNIDADE':
              nomeArquivo += '-monitoramento-coeficiente-desempenho-unidade';
              titulo = 'Coeficiente de Desempenho dos Servidores da Unidade';
              participantes = `Unidade(s): ${this.unidades.replace('(', '').replace(')', '')}`;

              colunas.splice(1, 0, 'TIPO');
              linhas = desempenhos.map((d) => [
                d.usuario.nome,
                d.chefia ? 'GESTOR' : 'SERVIDOR',
                d.unidade.sigla,
                toDecimal(d.notaAgrupada),
                toDecimal(d.notaAgrupadaResponsabilidade),
                toDecimal(d.cds),
                this.getSituacaoCds(d.cds),
              ]);
              break;
            default:
              break;
          }

          periodoComportamental = inicioComportamental !== '' && fimComportamental !== ''
            ? `Período de avaliação comportamental: ${inicioComportamental} a ${fimComportamental}`
            : '';

          periodoResponsabilidade = inicioResponsabilidade !== '' && fimResponsabilidade !== ''
            ? `Período de avaliação de responsabilidades: ${inicioResponsabilidade} a ${fimResponsabilidade}`
            : '';

          const documento = {
            nome: `${nomeArquivo}-${diagnostico.id}`,
            orientacao: this.tipo === 'SERVIDOR' ? 'portrait' : 'landscape',
            cabecalho: {
              titulo,
              itens: [
                `Diagnóstico: ${diagnostico.nome}`,
                periodoComportamental,
                periodoResponsabilidade,
                participantes,
              ],
            },
            blocos: [
              {
                titulo: 'GRÁFICOS',
                itens: [{
                  tipo: 'imagem',
                  valor: await convertSvg(this.svg),
                  largura: 130,
                  altura: 100,
                }],
              },
              {
                titulo: 'RESULTADOS',
                itens: [{
                  tipo: 'tabela',
                  valor: { colunas, linhas, rodape },
                }],
              },
            ],
          };

          if (desempenhos.length > 1) {
            documento.blocos.push({
              itens: [{
                tipo: 'tabela',
                valor: {
                  simples: true,
                  largura: 160,
                  colunas: ['RESUMO', 'RESULTADO COMPORTAMENTAL', 'RESULTADO TÉCNICO', 'CDS'],
                  linhas: [
                    [
                      'MÉDIA',
                      toDecimal(mean(desempenhos.map((d) => d.notaAgrupada))),
                      toDecimal(mean(desempenhos.map((d) => d.notaAgrupadaResponsabilidade))),
                      toDecimal(mean(desempenhos.map((d) => d.cds))),
                    ],
                    [
                      'DESVIO PADRÃO',
                      toDecimal(std(desempenhos.map((d) => d.notaAgrupada))),
                      toDecimal(std(desempenhos.map((d) => d.notaAgrupadaResponsabilidade))),
                      toDecimal(std(desempenhos.map((d) => d.cds))),
                    ],
                  ],
                },
              }],
            });
          }

          generatePDF(documento);
        }
      });
      this.isGetSvg = false;
    },
    getSituacaoCds(cds) {
      if (cds < 4) {
        return 'Não Atende';
      }
      if (cds >= 4 && cds < 8) {
        return 'Em Desenvolvimento';
      }
      return 'Atende';
    },
  },
};
</script>

<style scoped>
.bubble-chart {
  width: 600px;
  height: 600px;
  font-family: Roboto, sans-serif;
}

.gauge-chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}
</style>
